import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles((theme) => ({
  counteStyle: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "black",
  },
}));

const ReliefAllotment = (props) => {
  const classes = useStyles();

  return (
    <>
      {props.dayState.date ? (
        <div data-testid="relief-allotment">
          <Grid
            container
            justifyContent={"flex-end"}
            sx={{ paddingRight: "5px", fontWeight: "normal", fontSize: "16px", color: "primary.swaBlue" }}
          >
            {props.dayState.date.slice(-2)}
          </Grid>
          {(props.dayState.amOrPmCount > 0 || props.dayState.amCount > 0) &&
            (props.dayState.amOrPmCount > 0 ? (
              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "primary.swaBlue",
                  textAlign: "center",
                  padding: "10px",
                }}
              >
                <Grid item md={12} sx={{ marginTop: "20px" }}>
                  AM OR PM
                </Grid>
                <Typography component="span" className={classes.counteStyle}>
                  {props.dayState.amOrPmCount}
                </Typography>
              </Grid>
            ) : (
              <Grid
                sx={{
                  textAlign: "center",
                  padding: "10px",
                }}
              >
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    fontSize: "10px",
                    fontWeight: "bold",
                    marginTop: "20px",
                    color: "primary.swaBlue",
                  }}
                >
                  <Grid>
                    <Grid>AM</Grid>
                    <Typography component="span" className={classes.counteStyle}>
                      {props.dayState.amCount}
                    </Typography>
                  </Grid>
                  <Grid>
                    <Grid>PM</Grid>
                    <Typography component="span" className={classes.counteStyle}>
                      {props.dayState.pmCount}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

ReliefAllotment.propTypes = {
  dayState: PropTypes.object.isRequired,
};

export default ReliefAllotment;
